import { applyMiddleware, combineReducers, createStore } from 'redux'
import logger from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'
import { contactsReducer, ContactsState } from './states/contacts'

export type AppState = {
	contactsState: ContactsState
}

const store = createStore(
	combineReducers<AppState>({
		contactsState: contactsReducer
	}),
	composeWithDevTools(
		applyMiddleware(logger)
	)
)

export default store



// WEBPACK FOOTER //
// ./src/store.ts